// extracted by mini-css-extract-plugin
module.exports = {"input":"FormInput_input__CxUyA","formInput--error":"FormInput_formInput--error__22Iie","rotation":"FormInput_rotation__XoRL1"};